import moment from "moment-timezone";

/** Zona operativa del negocio (cierres, cajas, pagos por día calendario). */
export const OPERATIONAL_TIMEZONE = "America/Bogota";

/** `moment` anclado a la zona operativa (preferir esto a `moment()` sin tz). */
export function operationalMoment(): moment.Moment {
  return moment.tz(OPERATIONAL_TIMEZONE);
}

/** Fecha calendario hoy en zona operativa (YYYY-MM-DD). */
export function nowOperationalDateString(): string {
  return operationalMoment().format("YYYY-MM-DD");
}

/** Fecha y hora actual en zona operativa para persistir (YYYY-MM-DD HH:mm:ss). */
export function nowOperationalDateTimeString(): string {
  return operationalMoment().format("YYYY-MM-DD HH:mm:ss");
}

/** El menor de dos fechas calendario YYYY-MM-DD (comparación lexicográfica). */
export function minYmd(a: string, b: string): string {
  if (!a) return b;
  if (!b) return a;
  return a <= b ? a : b;
}

/**
 * Interpreta valores de fecha/hora del backend o de inputs y devuelve solo la fecha calendario en zona operativa.
 * Evita `new Date(x).toISOString().split('T')[0]` (UTC).
 */
export function formatOperationalDateOnly(raw: string | Date | null | undefined): string {
  if (raw == null || raw === "") {
    return "";
  }
  if (raw instanceof Date) {
    return moment(raw).tz(OPERATIONAL_TIMEZONE).format("YYYY-MM-DD");
  }
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}T/.test(s) && (s.endsWith("Z") || /[+-]\d{2}/.test(s))) {
    return moment.utc(s).tz(OPERATIONAL_TIMEZONE).format("YYYY-MM-DD");
  }
  const m = moment.tz(s, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD"], OPERATIONAL_TIMEZONE);
  return m.isValid() ? m.format("YYYY-MM-DD") : "";
}
